
<div class="modal-header bg-light pb-0">
	<h4 class="modal-title" id="modal-basic-title  "><strong>Record pick up</strong></h4>
    <button type="button" class="close border-0" aria-label="Close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"> 
    <span aria-hidden="true">&times;</span> 
	</button>
</div>
<hr>
<div class="modal-body bg-light">
	<form [formGroup]="gaugeTitleForm" (ngSubmit)="onSubmit()">
		<table>
			<thead class="collection">
				<tr>
					<td class="quantity"><b>Quantity Collected</b></td>
					<td class="date ml-20 "><b>Date Collected</b></td>
				</tr>
			</thead>
		 <hr class="collection-hr">
		 <tbody formArrayName="gaugeTitles" *ngFor="let item of gaugeTitleForm.get('gaugeTitles')['controls']; let i = index;">
			<tr [formGroupName]="i">
				<td>
					<div class="input-group-append-second">
						<div class="form-group">
							<div class="input-group">
								<div class="input-group-prepend"> </div>
								<input class="form-control form-control-lg bg-white  ff-normal h-30" type="text" (keypress)="quantityValidation($event)" restrictDecimaNumber placeholder="" formControlName="name" /> </div>
						</div>
					</div>
				</td>
				<td>
					<div class="input-group-append">
						<div class="form-group">
							<div class="input-group">
								<div class="input-group-prepend"> </div>
								<input type="text"  placeholder="" readonly class="form-control form-control-lg bg-white  ff-normal h-40" formControlName="secondDateRange" ngbDatepicker #d2="ngbDatepicker"  (click)="d2.toggle()" [value]=changeDateFormat(item.controls.secondDateRange.value) />
								<!-- <i class="far pickup-calendar"  ><img src="/images/calendar.svg" alt="customlogo" width="18px" height="18px" (click)="d2.toggle()"></i> -->
								</div>
						</div>
							<fieldset>
								<!-- <date-range-picker [options]="singleFieldOptions" [parentFormGroup]="item" controlName="singleField" (rangeSelected)="onRangeSelected($event)" formControlName="secondDateRange" #dateRangePicker></date-range-picker> -->
								<!-- <date-range-picker [instanceId]="'date'+i" [options]="singleFieldOptions" [parentFormGroup]="item" [controlName]="'name' + i" (rangeSelected)="onRangeSelected($event)" (datepickerReset)="onReset($event)" #dateRangePicker>
									<div class="form-group new-calendar">
										<div class="input-group">
											<div class="input-group-prepend">
											</div>
											<input [value]="dateRangePicker.range" formControlName="secondDateRange" class="form-control form-control-lg bg-white  ff-normal h-40" type="text"  placeholder=""   readonly/>
										</div>
									<i class="far pickup-calendar"  ><img src="/images/calendar.svg" alt="customlogo" [id]="'date'+i" name="'name' + i" width="18px" height="18px"></i>
								</div>
								</date-range-picker> -->
								
							</fieldset>
					   
					</div>
					
				</td> <i class="fas fa-minus-circle" (click)="removeRow(i)" *ngIf="i>0"></i> </tr>
				<hr class="sub-body-hr">
		</tbody>
		<td><i class="fa fa-plus add"  aria-hidden="true" (click)="addItem()"> </i></td>
					<span class="add-row"  aria-hidden="true" (click)="addItem()">Add row</span>
		</table>
		</form>
	</div>
	<hr class="body-hr">
	<div class="modal-footer bg-light foot">
		<button type="button" class="btn btn-cancel" (click)="activeModal.dismiss('close click')" data-dismiss="modal">Cancel</button>
		<button type="button" class="btn btn-primary" (click)="onSubmit()" [disabled]="!gaugeTitles.valid">Save</button>
	</div>

	